/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ service: NonNullable<unknown>, name: NonNullable<unknown> }} Landing_Gate_BodyInputs */

const en_landing_gate_body = /** @type {(inputs: Landing_Gate_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} with ${i?.name}. Your pick comes with you.`)
};

const pl_landing_gate_body = /** @type {(inputs: Landing_Gate_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.service} u ${i?.name}. Twój wybór idzie z Tobą.`)
};

/**
* | output |
* | --- |
* | "{service} with {name}. Your pick comes with you." |
*
* @param {Landing_Gate_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_gate_body = /** @type {((inputs: Landing_Gate_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Gate_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_gate_body(inputs)
	return en_landing_gate_body(inputs)
});